import { styled } from '@/stitches.config';

export const Box = styled('div', {});

Box.displayName = 'Box';
